import { FESTIVAL_TYPE } from "../../types";

export const festivalColors = {
  [FESTIVAL_TYPE.WONDER]: {
    introColor:
      "bg-[linear-gradient(286.89deg,_#0B2360_-5.83%,_#87A5E8_109.09%)]",
    introColorMobile:
      "bg-[linear-gradient(307.46deg,_#0B2360_19.1%,_#87A5E8_124.67%)]",
    introBeforeColor: "before:bg-[#E9F3FC]",
    introAfterColor: "before:bg-[#E9F3FC]",
    introSecondBgColor: "bg-[#0C365C]",
    introLittleCircleColor: "bg-[#FFA98D]",
    introTopBoxColor: "text-[#FD9800]",
    introMiddleBoxColor: "text-[#186DB7]",
    introBottomBoxColor: "text-[#186DB7]",
    title: "text-[#F9D854]",
    countDown: {
      textColor: "text-[#18181B]",
      textColorMobile: "text-[#18181B]",
      numberColor: "text-[#FFFFFF]",
      numberColorMobile: "text-[#FFFFFF]",
      numberBackgroundColor: "bg-[#ED752F]",
      textBackgroundColor: "bg-[#F7CBA7]",
    },
  },
  [FESTIVAL_TYPE.PERCENT]: {
    introColor: "gradientBg",
    introColorMobile: "gradientBg",
    introBeforeColor: "before:bg-[#F6F3EA]",
    introAfterColor: "before:bg-[#F6F3EA]",
    introSecondBgColor: "bg-[#C3E7D8]",
    introLittleCircleColor: "bg-[#C3E7D8]",
    introTopBoxColor: "text-[#E6835C]",
    introMiddleBoxColor: "text-[#4F7CD9]",
    introBottomBoxColor: "text-[#4F7CD9]",
    title: "text-[#F9D854]",
    countDown: {
      textColor: "text-[#202123]",
      textColorMobile: "text-[#18181B]",
      numberColor: "text-[#202123]",
      numberColorMobile: "text-[#18181B]",
      numberBackgroundColor: "bg-[#FFC267]",
      textBackgroundColor: "bg-[#FFDEA2]",
    },
  },
  [FESTIVAL_TYPE.STEPPED_AMOUNT]: {
    introColor: "bg-[#FBF0EA]",
    introColorMobile: "gradientBg",
    introBeforeColor: "before:bg-[#E9F3FC]",
    introAfterColor: "before:bg-[#E9F3FC]",
    introSecondBgColor: "bg-[#5097EB]",
    introLittleCircleColor: "bg-[#FFA98D]",
    introTopBoxColor: "text-[#F2683C]",
    introMiddleBoxColor: "text-[#186DB7]",
    introBottomBoxColor: "text-[#186DB7]",
    title: "",
    countDown: {
      textColor: "text-[#18181B]",
      textColorMobile: "text-[#18181B]",
      numberColor: "text-[#FFFFFF]",
      numberColorMobile: "text-[#FFFFFF]",
      numberBackgroundColor: "bg-[#ED752F]",
      textBackgroundColor: "bg-[#F7CBA7]",
    },
  },
  [FESTIVAL_TYPE.STEPPED_COUNT]: {
    introColor: "bg-[#FBF0EA;]",
    introColorMobile: "gradientBg",
    introBeforeColor: "before:bg-[#E9F3FC]",
    introAfterColor: "before:bg-[#E9F3FC]",
    introSecondBgColor: "bg-[#5097EB]",
    introLittleCircleColor: "bg-[#FFA98D]",
    introTopBoxColor: "text-[#F2683C]",
    introMiddleBoxColor: "text-[#186DB7]",
    introBottomBoxColor: "text-[#186DB7]",
    title: "",
    countDown: {
      textColor: "text-[#18181B]",
      textColorMobile: "text-[#18181B]",
      numberColor: "text-[#FFFFFF]",
      numberColorMobile: "text-[#FFFFFF]",
      numberBackgroundColor: "bg-[#ED752F]",
      textBackgroundColor: "bg-[#F7CBA7]",
    },
  },
};

export const festivalCountdownColor = {
  [FESTIVAL_TYPE.WONDER]: "bg-fdPrimary-10",
  [FESTIVAL_TYPE.PERCENT]: "bg-[#DFD7F0]",
  [FESTIVAL_TYPE.STEPPED_AMOUNT]: "bg-[#D4E9FE]",
  [FESTIVAL_TYPE.STEPPED_COUNT]: "bg-[#D4E9FE]",
};

export const festivalFooterColor = {
  [FESTIVAL_TYPE.WONDER]:
    "bg-[linear-gradient(286.89deg,_#0B2360_-5.83%,_#87A5E8_109.09%)]",
  [FESTIVAL_TYPE.PERCENT]: "bg-[#77D8CD]",
  [FESTIVAL_TYPE.STEPPED_AMOUNT]: "bg-fdPrimary-10",
  [FESTIVAL_TYPE.STEPPED_COUNT]: "bg-fdPrimary-10",
};
